var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "confirm",
        {
          staticClass: "big no-padding-confirm",
          attrs: {
            closeIcon: true,
            showMask: true,
            title: _vm.$t("tradeDividend.unlockList.title"),
            close: _vm.close
          }
        },
        [
          _c(
            "wallet-table",
            {
              staticClass: "trade-list-table",
              attrs: { headList: _vm.heads, contentList: _vm.contentList }
            },
            [
              _c("pagination", {
                staticClass: "__tb_pagination",
                attrs: {
                  slot: "tableBottom",
                  totalPage: _vm.totalPage,
                  currentPage: _vm.pageIndex + 1,
                  toPage: _vm.getCancellingList
                },
                slot: "tableBottom"
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }